import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [{
    path: '/index',
    component: () => import('../pages/index.vue'),
    children: [{
        path: "/home",
        component: () => import('../views/home.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: '/cate',
        component: () => import('../views/cate.vue'),
        meta: {
          title: "分类"
        }
      },
      {
        path: '/cart',
        component: () => import('../views/cart.vue'),
        name: "购物车",
        meta: {
          title: '购物车'
        }
      },
      {
        path: "/mine",
        component: () => import('../pages/mine.vue'),
        meta: {
          title: '个人中心'
        }
      },
      {
        path: "",
        redirect: '/home'
      }
    ]
  },
  {
    path: '/applicationList',
    component: () => import('../pages/applicationList.vue'),
    meta: {
      title: '内部费用申请表'
    }
  },
  {
    path: '/applicationForm',
    component: () => import('../pages/applicationForm.vue'),
    meta: {
      title: '内部费用申请表'
    }
  },
  {
    path: '/applicationDetails',
    component: () => import('../pages/applicationDetails.vue'),
    meta: {
      title: '内部费用申请表'
    }
  },
  {
    path: '/create',
    component: () => import('../pages/order.vue'),
    meta: {
      title: '创建告知函'
    }
  },
  {
    path: '/checklist',
    component: () => import('../pages/checklist.vue'),
    meta: {
      title: '项目资料清单'
    }
  },
  {
    path: '/createProject',
    component: () => import('../pages/createProject.vue'),
    meta: {
      title: '创建项目清单'
    }
  },
  {
    path: '/projectDetails',
    component: () => import('../pages/projectDetails.vue'),
    meta: {
      title: '确认详情'
    }
  },
  {
    path: '/projectDetail',
    component: () => import('../pages/projectDetail.vue'),
    meta: {
      title: '修改详情'
    }
  },
  {
    path: '/scanCodeDetails',
    component: () => import('../pages/scanCodeDetails.vue'),
    meta: {
      title: '扫码详情'
    }
  },
  {
    path: '/printDetails',
    component: () => import('../pages/printDetails.vue'),
    meta: {
      title: '打印'
    }
  },
  {
    path: '/printList',
    component: () => import('../pages/printList.vue'),
    meta: {
      title: '打印列表'
    }
  },
  {
    path: '/ticketDetails',
    component: () => import('../pages/ticketDetails.vue'),
    meta: {
      title: '小票详情'
    }
  },
  
  {
    path: '/success',
    component: () => import('../pages/success.vue'),
    meta: {
      title: '提交成功'
    }
  },
  {
    path: '/list',
    component: () => import('../pages/list.vue'),
    meta: {
      title: '商品列表'
    }
  },
  {
    path: '/detail',
    component: () => import('../pages/detail.vue'),
    meta: {
      title: '商品详情'
    }
  },
  {
    path: '/register',
    component: () => import('../pages/register.vue'),
    meta: {
      title: '注册',
    }
  },
  {
    path: '/login',
    component: () => import('../pages/login.vue'),
    meta: {
      title: '登录',
    }
  },
  {
    path: '/addlist',
    component: () => import('../pages/addlist.vue'),
    meat: {
      title: '地址列表',
    }
  },
  {
    path: "/addAddress",
    component: () => import("../pages/addAddress.vue"),
    meta: {
      title: "地址的添加",
    },
  },
  {
    path: '/pay',
    component: () => import("../pages/pay.vue"),
    meta: {
      title: '支付页面'
    }
  },
  {
    path: '*',
    redirect: '/'
  }
]
const router = new VueRouter({
  // mode:'history',// 历史模式
  base: process.env.BASE_URL, //环境地址
  routes,
})

// router.beforeEach((to, from, next) => {
//   //一、如果用户去的页面就是登录，我们直接next
//   if (to.path == '/login') {
//     next()
//     //结束当前逻辑
//     return
//   }
//    if (to.path == '/register') {
//     next()
//     return
//   }
//   //二、它去非登录页面，我们要判断它是否登录，如果登录就next
//   if (sessionStorage.getItem('isLogin')) {
//     next()
//     return
//   } 
//   //以上都不符合的条件，我们就拦截，我们就一直保持留在登录页
//   next('/login')
// })


export default router